module.exports = __webpack_public_path__ + "static/media/img_cws_bg_h.c0f38f2c.jpg";